import React from 'react'
import './articles.css'
const RegisterQKB = () => {
  return (
    <div class="articlecontainer">
    <header>
      <h1>How to Register Your Business in Albania: A Step-by-Step Guide for Foreigners</h1>
      <p>If you're a foreign entrepreneur looking to start a business in Albania, the process is straightforward and fast. The <strong>National Business Center (QKB)</strong> is responsible for business registration, ensuring your company is legally recognized. Follow this step-by-step guide to successfully register your business.</p>
    </header>

    <section class="step">
      <h2>Step 1: Choose a Business Name & Determine Where to Register</h2>
      <p>Albanian citizens can register their business online through the <strong>e-Albania</strong> platform.</p>
      <p>Foreign citizens must visit the <strong>National Business Center (QKB)</strong> in person unless they have an Albanian residence permit, which allows online registration.</p>
      <p><strong>Alternative option:</strong> If you can’t be present, a legal representative with a <strong>Power of Attorney</strong> can complete the registration for you.</p>
      <p>Before applying, make sure your business name is unique by checking its availability through QKB or at their office.</p>
    </section>

    <section class="step">
      <h2>Step 2: Gather the Required Documents</h2>
      <p>The exact documents you need depend on the legal structure of your business (<strong>LLC, Sole Proprietorship, Joint Stock Company</strong>, etc.). However, in general, the most commonly required documents are:</p>
      <ul>
        <li><strong>Company Name</strong> – The official name of your business.</li>
        <li><strong>Business Activity Description</strong> – A short summary of what your company will do.</li>
        <li><strong>Office Address</strong> – The official registered location of your business in Albania.</li>
        <li><strong>Shareholder Information</strong> – Details of all owners, including ownership percentages.</li>
        <li><strong>Minimum Paid-Up Capital</strong> – At least <strong>100 Albanian Lekë (ALL)</strong> must be declared.</li>
        <li><strong>Identification Documents</strong> – A valid passport for foreign owners or representatives.</li>
        <li><strong>Company Formation Documents:</strong>
          <ul>
            <li>The <strong>Act of Establishment</strong> (official company creation document).</li>
            <li>The <strong>Articles of Association</strong> (outlining the company’s structure, rights, and responsibilities).</li>
          </ul>
        </li>
        <li><strong>Power of Attorney</strong> – Required if someone else is registering the business on your behalf.</li>
      </ul>
    </section>

    <section class="step">
      <h2>Step 3: Translate and Notarize Foreign Documents</h2>
      <p>If any of your documents (e.g., passports, business licenses, contracts) are from another country, they must be translated and notarized before submission.</p>
      <ul>
        <li>All documents must be in <strong>Albanian</strong>. If unavailable, they can be in <strong>English and Albanian</strong>.</li>
        <li>Notarization must be done by a certified notary in Albania.</li>
      </ul>
    </section>

    <section class="step">
      <h2>Step 4: Submit Your Application to QKB</h2>
      <p>To officially register your business, foreigners must apply in person at a QKB office unless they have Albanian residency, in which case online registration via <strong>e-Albania</strong> is an option.</p>
      <p><strong>Ways to submit your application:</strong></p>
      <ul>
        <li><strong>Register in person</strong> – Visit a QKB office in Albania.</li>
        <li><strong>Appoint a legal representative</strong> – If you are not in Albania, your legal representative can complete the process for you with a <strong>Power of Attorney</strong>.</li>
      </ul>
      <p>Once your application is processed (usually within <strong>24 hours</strong>), your business will be officially registered! 🎉</p>
    </section>

    <footer>
      <p><strong>Final Thoughts:</strong> Registering a business in Albania is quick and efficient, as long as you have the right documents prepared. By following these steps, you can establish your company and start operating in Albania without complications.</p>
    </footer>
  </div>
  )
}

export default RegisterQKB